
export default {
  data() {
    return {
      showPanel: false,
    }
  },
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    pinned: {
      default: false,
    },
    active: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    HANDLE_CLICK() {
      this.showPanel = !this.showPanel
      this.$emit('click', this.showPanel)
    },
  },
}
